import { TASK_CONST } from '@/constant';
import type { FrameData, Task, WorkProgress } from '@/type';

export const getFrameState = (
  frame: FrameData,
  task?: Task,
): Nullish<WorkProgress> => {
  const frameWorkStateMap: {
    [key in Capitalize<TASK_CONST.TASK_FRAME_WORKSTATE>]: WorkProgress;
  } = {
    [TASK_CONST.TASK_FRAME_WORKSTATE.DONE]: 'Completed',
    [TASK_CONST.TASK_FRAME_WORKSTATE.PREWORK]: 'Not started',
    [TASK_CONST.TASK_FRAME_WORKSTATE.REJECT]: 'Rejected',
    [TASK_CONST.TASK_FRAME_WORKSTATE.REVIEW]: 'Submitted',
    [TASK_CONST.TASK_FRAME_WORKSTATE.REVIEWING]: 'In review',
    [TASK_CONST.TASK_FRAME_WORKSTATE.WORKING]: 'In progress',
    [TASK_CONST.TASK_FRAME_WORKSTATE.VIEW_ONLY]: 'View Only',
  } as const;

  if (frame.workState !== 'Prework') return frameWorkStateMap[frame.workState];

  return task?.operation?.find(o => o.operationType === 'AIAnnotation')
    ?.operationState === 'Running'
    ? 'AI-anno'
    : frameWorkStateMap[frame.workState];
};
